import { createContext } from 'react'
import type { LoyaltyRules } from '../../../types/loyalty'

/**
 * Page-scope context for the Loyalty module. The members-list state has moved
 * to MembersContext (see `./MembersContext.ts`) so its data only loads when
 * the Members tab is mounted.
 *
 * The loyalty **rules** document, by contrast, is page-scope: it powers the
 * Points tab editor AND the tier-progress card in the member drawer, so it is
 * fetched once here when the page mounts and shared via this context. Both
 * consumers should read `rules` from this context rather than calling
 * `useLoyaltyRulesQuery` themselves.
 */
export interface LoyaltyContextValue {
  storeId: string
  rules: LoyaltyRules | undefined
  rulesLoading: boolean
  rulesError: boolean
  refetchRules: () => void
}

export const LoyaltyContext = createContext<LoyaltyContextValue | undefined>(
  undefined,
)
